/**
 * Common object name for all dev testing related override properties
 */
const FluidDevOverridesKey: string = 'fluidDevOverrides';

/**
 * Use this method to get the object that stores the developer settings on parent window object.
 * Object is returned if it is available. Otherwise, undefined is returned.
 */
export function getFluidDevOverrides(settingName: string): any | undefined {
  try {
    // @ts-ignore Ignore fluidDevSettings does not exist on window object error
    return window.top[FluidDevOverridesKey]?.[settingName];
  } catch (_) {
    return undefined;
  }
}
